module.exports = __webpack_public_path__ + "img/logo.b89b921a.svg";